export const AttentionBubble = () => (
  <div className="absolute m-2 inline-flex">
    <div className="absolute inline-flex size-full animate-ping rounded-full bg-secondary-75 opacity-75" />
    <div className="relative inline-flex size-3 rounded-full bg-secondary-100" />
  </div>
);
